/**
 * 异常类型创建或编辑
 */
import React from 'react';
import {
    Modal,
    message,
    Form,
    Input,
    InputNumber,
    Radio,
    Select
} from 'antd';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import styles from './index.module.scss';
import http from '@/assets/api/http';
// import model from '@/reducers/systemanage/parameter/model';


const FormItem = Form.Item;//表单校验
const formItemLayout = {
    labelCol: {
        sm: { span: 5 },
    },
    wrapperCol: {
        sm: { span: 19 },
    },
};
const { Option } = Select;

class ReasonModal extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            titleTag: this.props.title,
            visible: this.props.visible,
            confirmLoading: false,
            typeInput: this.props.data === undefined ? '' : this.props.data.className, // 分类名称


        };

    }
    formRef = React.createRef();
    componentDidMount() {
    }

    componentWillUnmount() {
    }

    _handleCancel = () => {
        this.setState({
            visible: false,
        });
        this.props.closeMode();
    }


    handleSubmit = () => {//表单校验
        this.formRef.current.validateFields().then(async (fieldsValue) => {
            const { exceptionType, waiteTime, usageScenario, responsibleParty, processingLogic, sortNo, status } = fieldsValue;
            const { data } = this.props;

            let submitData = {
                id: data ? data.id : undefined,
                exceptionType,
                waiteTime,
                usageScenario,
                responsibleParty,
                processingLogic,
                sortNo,
                status
            };

            this.setState({ confirmLoading: true }, () => {
                http('/?cmd=com.xqxc.api.pig.mis.biz.platform.ExceptionTypesMisService.updateExceptionTypes', submitData, 'POST').then(() => {
                    data ? message.success('更新成功') : message.success('新建成功');
                    this.setState({
                        confirmLoading: false,
                        visible: false,
                    });
                    this.props.closeMode(true);
                }).catch((e = {}) => {
                    message.error(e.message);
                    this.setState({
                        confirmLoading: false,
                    });
                });
            });

        });
    };


    render() {
        const { visible, confirmLoading, titleTag } = this.state;
        const { data = {} } = this.props;
        const {
            exceptionType,
            waiteTime,
            usageScenario,
            responsibleParty,
            processingLogic,
            sortNo,
            status
        } = data;

        return (
            <Modal
                width={470}
                centered
                title={titleTag}
                open={visible}
                confirmLoading={confirmLoading}
                onOk={this.handleSubmit}
                onCancel={this._handleCancel}
                destroyOnClose={true}
                keyboard={true}
                maskClosable={false}
                cancelText='取消'
                okText='确认'
            >
                <div className={styles.container}>
                    <Form {...formItemLayout} className="create-form" ref={this.formRef}>
                        <FormItem
                            name='exceptionType'
                            label='异常类型'
                            rules={[{ required: true, message: '异常类型', whitespace: true }]}
                            initialValue={exceptionType}
                        >
                            <Input maxLength={24} placeholder='请输入' />
                        </FormItem>
                        {/* <FormItem
                            name='waiteTime'
                            label='等待时长'
                            rules={[{ required: true, message: '请输入等待时长！' }]}
                            initialValue={waiteTime}
                        >

                            <InputNumber
                                style={{ width: '100%' }}
                                min={1}
                                max={99}
                                precision={0}
                                placeholder='请输入'
                                 addonAfter="分钟"
                            />

                        </FormItem> */}
                        {/* <FormItem
                            name='usageScenario'
                            label='使用场景'
                            rules={[{ required: true, message: '请选择使用场景', whitespace: true }]}
                            initialValue={usageScenario}
                        >
                            <Select placeholder='请输入' disabled>
                                <Option value={'USER'}>用户</Option>
                                <Option value={'RIDER'}>骑手</Option>
                            </Select>
                        </FormItem> */}
                        <FormItem
                            name='responsibleParty'
                            label='责任方'
                            rules={[{ required: true, message: '请选择责任方', whitespace: true }]}
                            initialValue={responsibleParty}
                        >
                            <Select placeholder='请输入' disabled>
                                <Option value={'USER'}>用户</Option>
                                <Option value={'RIDER'}>骑手</Option>
                            </Select>
                        </FormItem>
                        <FormItem
                            name='processingLogic'
                            label='处理逻辑'
                            rules={[{ required: true, message: '请选择处理逻辑', whitespace: true }]}
                            initialValue={processingLogic}
                        >
                            <Select placeholder='请输入' disabled>
                                <Option value={'PROCESSING_LOGIC_ONE'}>等同用户取消，需支付违约金</Option>
                                <Option value={'PROCESSING_LOGIC_TWO'}>骑手送回快件，等同骑手送达</Option>
                            </Select>
                        </FormItem>
                        <FormItem
                            name='sortNo'
                            label='排序'
                            rules={[{ required: true, message: '请输入排序' }]}
                            initialValue={sortNo}
                        >

                            <InputNumber
                                style={{ width: '100%' }}
                                min={1}
                                max={99}
                                precision={0}
                                placeholder='请输入'
                            />

                        </FormItem>
                        <FormItem
                            name='status'
                            label='状态'
                            rules={[{ required: true, message: '请选择状态' }]}
                            initialValue={status}
                        >

                            <Radio.Group>
                                <Radio value={1}>启用</Radio>
                                <Radio value={0}>停用</Radio>
                            </Radio.Group>

                        </FormItem>
                    </Form>
                </div>
            </Modal>
        );

    }
}

ReasonModal.propTypes = {
    data: PropTypes.object, // 弹框入参
    visible: PropTypes.bool.isRequired, // 是否显示弹框
    closeMode: PropTypes.func.isRequired, // 关闭弹框的回调函数
    title: PropTypes.string,// 弹框标题
};

const mapStateToProps = (state) => {
    return {
    };
};
export default connect(mapStateToProps)(ReasonModal);